export default class Select {
  constructor() {
    this.init();
  }
  init() {
    const multi = $(".esf-select__field--multi");

    multi.select2();
  }
}
